var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4629_58667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.668 19.9998V20.7998H49.568C39.668 20.7998 35.068 25.3998 35.068 35.2998V52.3332H32.5013V64.1665H35.068V69.1665H16.5013C15.1346 69.1665 14.0013 68.0332 14.0013 66.6665C14.0013 65.2998 15.1346 64.1665 16.5013 64.1665H27.5013V52.3332H20.0013C9.56797 52.3332 6.76797 49.7665 6.66797 39.6665V19.9998C6.66797 9.33317 9.33464 6.6665 20.0013 6.6665H53.3346C64.0013 6.6665 66.668 9.33317 66.668 19.9998Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.01 26H47.99C42.125 26 40 28.35 40 34.9535V64.0465C40 70.65 42.125 73 47.99 73H65.9887C71.875 73 74 70.65 74 64.0465V34.9535C74 28.35 71.875 26 66.01 26ZM57 66.655C54.96 66.655 53.2812 64.7985 53.2812 62.5425C53.2812 60.2865 54.96 58.43 57 58.43C59.04 58.43 60.7188 60.2865 60.7188 62.5425C60.7188 64.7985 59.04 66.655 57 66.655ZM61.25 35.9875H52.75C51.8787 35.9875 51.1562 35.1885 51.1562 34.225C51.1562 33.2615 51.8787 32.4625 52.75 32.4625H61.25C62.1213 32.4625 62.8438 33.2615 62.8438 34.225C62.8438 35.1885 62.1213 35.9875 61.25 35.9875Z",
    fill: "#C1E4F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4629_58667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.dc64347a87d13d2433d333e9fe07f70c.svg";
export { ForwardRef as ReactComponent };